import MyWalletTest from './MyWalletTest';
export default MyWalletTest;